(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/team/assets/javascripts/members.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/team/assets/javascripts/members.js');
"use strict";


const {
  useDispatch
} = ReactRedux;
const {
  ReactPaper,
  ReactIcon
} = svs.ui;
const {
  leaveTeam
} = svs.components.marketplaceCompetition.services.actions.teamsActions;
const {
  unwrapResult
} = RTK;
const {
  showDialogAction
} = svs.components.marketplaceCompetition.services.actions.dialogActions;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const logger = svs.core.log.getLogger('marketplace-competition:team');
const {
  processErrorCode
} = svs.components.marketplaceShared.competitionErrorCodes;
const {
  useIsBeforeSignupEndTime
} = svs.components.marketplaceCompetition.team.useCompetitionSignupTime;
const Members = _ref => {
  var _teamResult$data;
  let {
    currentTeam,
    currentUser,
    competition,
    teamResult
  } = _ref;
  const competitionId = useCompetitionId();
  const dispatch = useDispatch();
  const members = currentTeam.members || [];
  const memberMe = members.find(member => member.isCurrentMember);
  const getMemberStatus = member => member.hasPlayedCurrentRound ? 'Lämnat in spel' : 'Inte lämnat in spel';
  const getMemberName = member => "".concat(member.fullName).concat(member.isTeamOwner ? ' (Kapten)' : '');
  const getMembersTitle = () => currentTeam !== null && currentTeam !== void 0 && currentTeam.competitionHasStarted ? 'Lagets medlemmar' : "Lagets medlemmar (".concat(members.length, " av ").concat(currentTeam.maxNumMembers || '?', ")");
  const createDialog = (dialogTitle, dialogIcon, dialogBtnText, cb) => {
    dispatch(showDialogAction({
      title: dialogTitle,
      icon: dialogIcon,
      buttons: [{
        text: 'Avbryt'
      }, {
        text: dialogBtnText,
        callback: () => {
          svs.ui.loader.show();
          cb();
        }
      }]
    }));
  };
  const removeMember = member => {
    const dialogIcon = 'penalty';
    const dialogBtnText = 'Ta bort';
    const dialogTitle = "Vill du ta bort ".concat(member.firstName, " ").concat(member.lastName, " fr\xE5n ").concat(currentTeam.name, "?");
    const cb = async () => {
      try {
        const resultAction = await dispatch(leaveTeam({
          competitionId,
          teamId: currentTeam.id,
          customerId: member.customerId
        }));
        const fullfilledPayload = unwrapResult(resultAction);
        if (fullfilledPayload) {
          svs.ui.loader.hide();
        }
      } catch (err) {
        const {
          errorTitle,
          errorMessage
        } = processErrorCode(err);
        svs.ui.loader.hide();
        logger.info("Mkp-competition: remove team member error: ".concat(err));
        dispatch(showDialogAction({
          title: errorTitle,
          text: errorMessage,
          type: 'error',
          icon: 'exclamation-sign',
          buttons: [{
            text: 'Okej'
          }]
        }));
      }
    };
    createDialog(dialogTitle, dialogIcon, dialogBtnText, cb);
  };
  const isBeforeSignupEndTime = useIsBeforeSignupEndTime({
    competition
  });
  const hasPlayedAnyRound = teamResult === null || teamResult === void 0 || (_teamResult$data = teamResult.data) === null || _teamResult$data === void 0 || (_teamResult$data = _teamResult$data.drawResults) === null || _teamResult$data === void 0 ? void 0 : _teamResult$data.some(drawResult => {
    var _drawResult$contribut;
    return drawResult === null || drawResult === void 0 || (_drawResult$contribut = drawResult.contributions) === null || _drawResult$contribut === void 0 ? void 0 : _drawResult$contribut.some(contribution => contribution === null || contribution === void 0 ? void 0 : contribution.hasPlayed);
  });
  const shouldShowRemove = member => {
    const canBeRemoved = isBeforeSignupEndTime && !hasPlayedAnyRound;
    const isAllowedToRemoveAsTeamOwner = currentUser.isTeamOwner && !member.isCurrentMember;
    const isAllowedToRemoveSelf = !member.isTeamOwner && member.isCurrentMember;
    return canBeRemoved && (isAllowedToRemoveAsTeamOwner || isAllowedToRemoveSelf);
  };
  const renderMember = member => React.createElement(ReactPaper, {
    branding: "sport",
    href: "/"
  }, React.createElement("div", {
    className: "member-item fc-navy"
  }, React.createElement("div", {
    className: "member-item-info"
  }, React.createElement("div", {
    className: "member-item-name f-medium"
  }, getMemberName(member)), React.createElement("div", {
    className: "member-item-status fc-grey-500"
  }, getMemberStatus(member))), Boolean(member.hasPlayedCurrentRound) && React.createElement("div", null, React.createElement("span", {
    className: "member-item-icon"
  }, React.createElement(ReactIcon, {
    color: "fc-white",
    icon: "nav-my-games",
    size: "100"
  }))), memberMe.isTeamOwner && shouldShowRemove(member) && React.createElement("div", {
    className: "member-remove"
  }, React.createElement("button", {
    "aria-label": "Ta bort medlem",
    className: "icon-button qa-remove-member",
    "data-testid": "qa-remove-member",
    onClick: () => removeMember(member),
    type: "button"
  }, React.createElement(ReactIcon, {
    icon: "dustbin",
    size: "300"
  })))));
  return React.createElement("div", {
    className: "competition-members",
    "data-testid": "qa-members"
  }, React.createElement("h3", {
    className: "competition-members-header",
    "data-testid": "qa-members-count"
  }, getMembersTitle()), members.map(member => React.createElement(React.Fragment, {
    key: member.id
  }, renderMember(member))));
};
setGlobal('svs.components.marketplaceCompetition.team.Members', Members);

 })(window);